import React from 'react';
import PropTypes from 'prop-types';

/**
 * A component that represents a label.
 * @param {Object} props - The props.
 * @param {string} props.alignment - The alignment.
 * @param {string} props.for - The for attribute.
 * @param {string} props.layout - The layout.
 * @param {string} props.scale - The scale.
 * @param {React.ReactNode} props.children - The children.
 * @returns {JSX.Element} The component.
 */
const CalciteLabel = ({alignment, for: forId, layout, scale, children, ...rest}) => {
  return (
    <calcite-label alignment={alignment} for={forId} layout={layout} scale={scale} {...rest}>
      {children}
    </calcite-label>
  );
};

CalciteLabel.propTypes = {
  alignment: PropTypes.oneOf(['start', 'center', 'end']),
  for: PropTypes.string,
  layout: PropTypes.oneOf(['default', 'inline', 'inline-space-between']),
  scale: PropTypes.oneOf(['s', 'm', 'l']),
  children: PropTypes.node,
};

export default CalciteLabel;
